if (typeof Liferay !== 'undefined') {
    Liferay.on('endNavigate', () => {
        initAccordion()
    })

    Liferay.on('beforeNavigate', () => {
        // Nettoyage complet pour la SPA Liferay
        window.CustomTreeAccordion = undefined;
    })
}

class CustomTreeAccordion {
    constructor(domNode) {
        this.rootEl = domNode;

        if (this.rootEl.hasAttribute('data-accordion-initialized')) return;

        this.objectId = (this.rootEl.getAttribute("id") || "").replace(/^accordion-/, "");
        this.buttonEl = this.rootEl.querySelector('#accordion-button-' + this.objectId);

        if (!this.buttonEl) return;

        const controlsId = this.buttonEl.getAttribute('aria-controls');
        this.contentEl = document.getElementById(controlsId);

        this.isOpen = this.buttonEl.getAttribute('aria-expanded') === 'true';

        if (this.isOpen) {
            this.contentEl.classList.remove('tw:hidden');
            this.buttonEl.setAttribute('aria-expanded', 'true');
        } else {
            this.contentEl.classList.add('tw:hidden');
            this.buttonEl.setAttribute('aria-expanded', 'false');
        }

        this.buttonEl.addEventListener('click', this.onButtonClick.bind(this));

        this.rootEl.setAttribute('data-accordion-initialized', 'true');
    }

    onButtonClick() {
        this.toggle(!this.isOpen);
    }

    toggle(open) {
        if (open === this.isOpen) return;
        this.isOpen = open;
        this.buttonEl.setAttribute('aria-expanded', `${open}`);
        if (open) {
            this.contentEl.classList.remove('tw:hidden');
        } else {
            this.contentEl.classList.add('tw:hidden');
        }
    }

    open() { this.toggle(true); }
    close() { this.toggle(false); }
}

function initAccordion(rootElement) {
    const baseElement = rootElement || document.querySelector('.notice--archive');

    if (baseElement) {
        // Enregistrement sur l'objet global window pour Liferay SPA
        window.CustomTreeAccordion = CustomTreeAccordion;

        if (baseElement.classList.contains('js-accordion')) {
            let accordion = new window.CustomTreeAccordion(baseElement);
            if (baseElement.querySelector(".current-archive")) {
                accordion.open();
            }
        } else {
            const accordions = baseElement.querySelectorAll('.js-accordion');
            accordions.forEach((accordionEl) => {
                let accordion = new window.CustomTreeAccordion(accordionEl);
                if (accordionEl.querySelector(".current-archive")) {
                    accordion.open();
                }
            });
        }
    }
}

// Lancement au premier chargement hors navigation SPA
initAccordion();